import Comments from '../../components/comments';
import Dashboard from '../../components/dashboard';
import Login from '../../components/login';
import Walls from '../../components/walls/index';
import Tags from '../../components/tags';
import Alert from '../../components/alerts';
import Users from '../../components/users';
import Wall from '../../components/wall';
import APIKeys from '../../components/keys';
import Posts from '../../components/posts/posts';
import PendingPost from '../../components/pending.posts';
import Event from '../../components/events';

export const routes = [
    {
        path: '/',
        component: Dashboard,
        isProtected: true,
        sidebarName: 'Home',
        icon: 'fa-tachometer',
        sidebar: true,
        admin: false
    },
    {
        path: '/login',
        component: Login,
        isProtected: false,
        sidebarName: 'Log in',
        sidebar: false,
        admin: false
    },
    {
        path: '/walls',
        component: Walls,
        isProtected: true,
        sidebarName: 'Honor Walls',
        icon: 'fa-th',
        sidebar: true,
        admin: false
    },
    {
        path: '/wall/:id',
        component: Wall,
        isProtected: true,
        sidebarName: 'Walls',
        icon: 'fa-list-alt',
        sidebar: false,
        admin: false
    },
    {
        path: '/posts',
        component: Posts,
        isProtected: true,
        sidebarName: 'Wall Posts',
        icon: 'fa-id-card-o',
        sidebar: false,
        admin: false
    },
    {
        path: '/pending-posts',
        component: PendingPost,
        isProtected: true,
        sidebarName: 'Wall Pending Posts',
        icon: 'fa-id-card-o',
        sidebar: true,
        admin: false
    },
    {
        path: '/chat',
        component: Comments,
        isProtected: true,
        sidebarName: 'Chat Channels',
        icon: 'fa-comments',
        sidebar: false,
        admin: false
    },
    {
        path: '/tags',
        component: Tags,
        isProtected: true,
        sidebarName: 'Honor Wall Tags',
        icon: 'fa fa-tags',
        sidebar: true,
        admin: false
    },
    {
        path: '/alerts',
        component: Alert,
        isProtected: true,
        sidebarName: 'Alerts',
        icon: 'fa-bell',
        sidebar: true,
        admin: false
    },
    {
        path: '/users',
        component: Users,
        isProtected: true,
        sidebarName: 'Users',
        icon: 'fa-user-circle-o',
        sidebar: true,
        admin: true
    },
    {
        path: '/keys',
        component: APIKeys,
        isProtected: true,
        sidebarName: 'API Keys',
        icon: 'fa-key',
        sidebar: true,
        admin: true
    },
    {
        path: '/events',
        component: Event,
        isProtected: true,
        sidebarName: 'Educational Events',
        icon: 'fa-calendar-o',
        sidebar: true,
        admin: false
    }
];